// removed by extract-text-webpack-plugin
module.exports = {"title":"_1h8u","subtitle":"-mmX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/resorthome/sectiontitle/style.css
// module id = 346
// module chunks = 9